(function () {
  const SELECTOR = "[data-free-shipping]";

  function formatGBPFromPence(pence) {
    // Basic GBP formatting (works fine for UK stores)
    const value = Math.max(0, pence) / 100;
    return new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: "GBP",
    }).format(value);
  }

  function updateAllBars(cartTotalPence) {
    document.querySelectorAll(SELECTOR).forEach((root) => {
      const threshold = parseInt(root.getAttribute("data-threshold"), 10) || 0;
      const remaining = threshold - cartTotalPence;

      const msgEl = root.querySelector("[data-free-shipping-message]");
      const fillEl = root.querySelector("[data-free-shipping-fill]");
      const barEl = root.querySelector(".free-shipping__bar");

      let progress = 0;

      if (remaining > 0) {
        progress = threshold > 0 ? (cartTotalPence / threshold) * 100 : 0;
        progress = Math.max(0, Math.min(100, progress));

        if (msgEl) {
          msgEl.textContent = `🎉 You’re only ${formatGBPFromPence(remaining)} away from FREE UK delivery`;
        }
      } else {
        progress = 100;
        if (msgEl) {
          msgEl.textContent = "🎉 You’ve unlocked FREE UK delivery!";
        }
      }

      if (fillEl) fillEl.style.width = `${progress}%`;
      if (barEl) barEl.setAttribute("aria-valuenow", String(Math.round(progress)));
    });
  }

  async function fetchCartTotal() {
    try {
      const res = await fetch("/cart.js", { credentials: "same-origin" });
      if (!res.ok) return null;
      const cart = await res.json();
      return cart && typeof cart.total_price === "number" ? cart.total_price : null;
    } catch (e) {
      return null;
    }
  }

  // Debounced refresh (quantity changes, remove item, etc.)
  let t = null;
  function scheduleRefresh() {
    clearTimeout(t);
    t = setTimeout(async () => {
      const total = await fetchCartTotal();
      if (total !== null) updateAllBars(total);
    }, 450);
  }

  // Initial
  document.addEventListener("DOMContentLoaded", async () => {
    const total = await fetchCartTotal();
    if (total !== null) updateAllBars(total);
  });

  // Listen for typical cart interactions (works in Dawn for both drawer & cart page)
  document.addEventListener("change", (e) => {
    // Quantity inputs in Dawn usually trigger ajax updates
    if (
      e.target &&
      (e.target.name === "updates[]" ||
        e.target.matches('input[name="updates[]"]') ||
        e.target.matches("cart-remove-button, [data-cart-remove]") ||
        e.target.closest("cart-items") ||
        e.target.closest("cart-drawer-items"))
    ) {
      scheduleRefresh();
    }
  });

  document.addEventListener("click", (e) => {
    // Remove buttons, plus/minus controls, etc.
    if (
      e.target &&
      (e.target.closest("cart-remove-button") ||
        e.target.closest("[data-cart-remove]") ||
        e.target.closest("button[name='update']") ||
        e.target.closest("a[href*='/cart/change']"))
    ) {
      scheduleRefresh();
    }
  });

  // Also run after ajax section re-renders (MutationObserver is robust for Dawn updates)
  const obs = new MutationObserver(() => {
    // If a bar exists, refresh its values
    if (document.querySelector(SELECTOR)) scheduleRefresh();
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
})();